import ServerConfigFilesViewer from "@/components/server-config-files-viewer"
import type { LogrotateConfig, Server } from "@/types"

interface LogrotateConfigsPageProps {
  server: Pick<Server, "id" | "name" | "hostname">
  configs: LogrotateConfig[]
}

export default function LogrotateConfigsPage({
  server,
  configs,
}: LogrotateConfigsPageProps) {
  return (
    <ServerConfigFilesViewer
      server={server}
      configs={configs}
      pageTitle="Logrotate Configs"
      headingTitle="Logrotate Configuration Files"
      directoryPath="/etc/logrotate.d/"
      breadcrumbTitle="Logrotate Configs"
    />
  )
}
